// Aktion „ROMY Tester": hält die ROMY Geheime Musteredition im Warenkorb, solange dort noch
// etwas anderes liegt. Wer, wo und wie viele: snippets/romy-tester-gift.liquid.
(() => {
  const config = window.romyTesterGift;
  if (!config || !config.variantId) return;

  // Warenkorb-Attribut, im Admin unter „Zusätzliche Details" der Bestellung sichtbar:
  // declined = Kunde hat die Tester entfernt, failed = ausverkauft oder Rabatt greift nicht.
  // Ist es gesetzt, legt das Skript keine Tester mehr nach.
  const ATTRIBUTE = '_romy_tester';
  const CART_MUTATION = /(^|\/)cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  const TESTER_ROW = `.cart-item:has([data-quantity-variant-id="${config.variantId}"])`;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const nativeFetch = window.fetch.bind(window);

  let removedByCustomer = false;
  let stopped = false;

  function testerQuantity(cart) {
    return cart.items
      .filter((item) => item.variant_id === config.variantId)
      .reduce((sum, item) => sum + item.quantity, 0);
  }

  function expectedQuantity(enabled, hasOtherItems, status, current) {
    if (!enabled || !hasOtherItems) return 0;
    if (status) return Math.min(current, config.quantity);
    return config.quantity;
  }

  function sectionIds() {
    const ids = ['cart-icon-bubble'];
    if (document.getElementById('CartDrawer')) ids.push('cart-drawer');
    ['main-cart-items', 'main-cart-footer'].forEach((id) => {
      const element = document.getElementById(id);
      if (element && element.dataset.id) ids.push(element.dataset.id);
    });
    return ids;
  }

  async function update(quantity, status) {
    const response = await nativeFetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: { [config.variantId]: quantity },
        attributes: { [ATTRIBUTE]: status },
        sections: sectionIds(),
        sections_url: window.location.pathname,
      }),
    });
    if (!response.ok) throw new Error(`cart/update.js ${response.status}`);
    return response.json();
  }

  // Wie CartDrawer.renderContents bzw. CartItems.onCartUpdate, nur ohne den Drawer zu öffnen.
  function render(cart) {
    const sections = cart.sections || {};
    const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
    const isEmpty = cart.item_count === 0;

    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      bubble.innerHTML = parse(sections['cart-icon-bubble']).querySelector('.shopify-section').innerHTML;
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      const html = parse(sections['cart-drawer']);
      if (!isEmpty && !drawer.classList.contains('is-empty')) {
        ['cart-drawer-items', '.cart-drawer__footer'].forEach((selector) => {
          const target = document.querySelector(selector);
          const source = html.querySelector(selector);
          if (target && source) target.replaceWith(source);
        });
      } else {
        const target = document.getElementById('CartDrawer');
        const source = html.getElementById('CartDrawer');
        if (target && source) target.innerHTML = source.innerHTML;
        const overlay = document.getElementById('CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
      }
      drawer.classList.toggle('is-empty', isEmpty);
    }

    ['main-cart-items', 'main-cart-footer'].forEach((id) => {
      const element = document.getElementById(id);
      if (!element || !sections[element.dataset.id]) return;
      const source = parse(sections[element.dataset.id]).querySelector('.js-contents');
      const target = element.querySelector('.js-contents') || element;
      if (source) target.innerHTML = source.innerHTML;
    });
    const cartItems = document.querySelector('cart-items');
    if (cartItems) cartItems.classList.toggle('is-empty', isEmpty);
    const cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) cartFooter.classList.toggle('is-empty', isEmpty);
  }

  async function sync() {
    const cart = await nativeFetch(`${root}cart.js`).then((response) => response.json());
    const current = testerQuantity(cart);
    const hasOtherItems = cart.items.some((item) => item.variant_id !== config.variantId);
    const savedStatus = cart.attributes[ATTRIBUTE] || '';
    let status = savedStatus;

    if (removedByCustomer && current === 0) {
      removedByCustomer = false;
      status = 'declined';
    }
    // Leerer Warenkorb = neuer Versuch, außer der Kunde hat die Tester abgelehnt.
    if (!hasOtherItems && status === 'failed') status = '';

    const target = expectedQuantity(config.enabled, hasOtherItems, status, current);
    if (target === current && status === savedStatus) return;

    let updated = await update(target, status);
    // Nie einen Tester berechnen und nicht endlos neu versuchen.
    const charged = updated.items.some(
      (item) => item.variant_id === config.variantId && item.final_line_price > 0
    );
    if (charged || (target > 0 && testerQuantity(updated) === 0)) {
      updated = await update(0, 'failed');
    }
    render(updated);
  }

  let timer;
  let running = false;
  let queued = false;

  async function run() {
    if (stopped) return;
    if (running) {
      queued = true;
      return;
    }
    running = true;
    try {
      await sync();
    } catch (error) {
      stopped = true;
      console.error('[romy-tester-gift]', error);
    }
    running = false;
    if (queued) {
      queued = false;
      run();
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 400);
  }

  // Jede Warenkorb-Änderung abfangen – Theme, Rapi-Widget und andere Apps.
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || String(input);
    const request = nativeFetch(input, init);
    if (CART_MUTATION.test(url)) request.then(schedule, schedule);
    return request;
  };

  const nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_MUTATION.test(String(url))) this.addEventListener('loadend', schedule);
    return nativeOpen.apply(this, arguments);
  };

  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest(`${TESTER_ROW} cart-remove-button`)) removedByCustomer = true;
    },
    true
  );

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) schedule();
  });

  const expected = expectedQuantity(config.enabled, config.othersInCart > 0, config.status, config.testerInCart);
  if (config.testerInCart !== expected) schedule();
})();
